import React from "react";
import { Star } from "lucide-react";

export function StarRating({ value, onChange, size = "h-9 w-9", readOnly = false }) {
  return (
    <div className="flex items-center justify-center gap-2" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((n) => (
        <button
          key={n}
          type="button"
          disabled={readOnly}
          data-testid={`star-${n}`}
          onClick={() => !readOnly && onChange?.(n)}
          className={`transition-transform ${readOnly ? "" : "active:scale-90 hover:scale-110"}`}
        >
          <Star
            className={size}
            strokeWidth={1.5}
            fill={n <= value ? "#F59E0B" : "none"}
            stroke={n <= value ? "#F59E0B" : "#CBD5E1"}
          />
        </button>
      ))}
    </div>
  );
}

export function StarsInline({ value, size = "h-4 w-4" }) {
  return (
    <span className="inline-flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} className={size} strokeWidth={1.5} fill={n <= Math.round(value) ? "#F59E0B" : "none"} stroke={n <= Math.round(value) ? "#F59E0B" : "#CBD5E1"} />
      ))}
    </span>
  );
}

export function QualityRing({ pct, avg, size = 96 }) {
  const has = pct != null;
  const p = has ? pct : 0;
  return (
    <div className="flex flex-col items-center">
      <div className="relative" style={{ height: size, width: size }}>
        <svg viewBox="0 0 36 36" className="-rotate-90" style={{ height: size, width: size }}>
          <circle cx="18" cy="18" r="15.9" fill="none" stroke="#E2E8F0" strokeWidth="3.5" />
          <circle cx="18" cy="18" r="15.9" fill="none" stroke="#F59E0B" strokeWidth="3.5"
            strokeDasharray={`${p} ${100 - p}`} strokeLinecap="round" />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          {has ? (
            <>
              <span className="tnum text-xl font-black text-amber-500">{pct}%</span>
              <span className="tnum text-[11px] font-bold text-slate-500">{avg} / 5</span>
            </>
          ) : (
            <span className="text-[10px] font-bold text-slate-400 text-center px-2">No ratings yet</span>
          )}
        </div>
      </div>
    </div>
  );
}
